import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currency',
    standalone: true
})

export class CurrencyPipe implements PipeTransform {
    transform(value: string | number) {
        const FORMAT = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: 'IDR',
            minimumFractionDigits: 0
        }).format(Number(value));
        
        return FORMAT;
    }
}